var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"remark",on:{"mouseover":function($event){_vm.open = true},"mouseout":function($event){_vm.open = false}}},[_vm._v(_vm._s(_vm.remark))]),_c('fm-poper',{attrs:{"value":_vm.open,"position":"right-end"}},[_c('div',{staticClass:"long-remark"},[_vm._v(" "+_vm._s(_vm.remark)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }